import { createContext, useContext } from 'react';
import ConfigStore from 'src/integration/store/ConfigStore/ConfigStore';
import ProfileStore from 'src/integration/store/ProfileStore/ProfileStore';
import DashboardStore from 'src/integration/store/DashboardStore/DashboardStore';
import OperationalDataStore from 'src/integration/store/OperationalDataStore/OperationalDataStore';
import SocAndBalancingStore from 'src/integration/store/SocAndBalancingStore/SocAndBalancingStore';
import PowerAndBalancingStore from 'src/integration/store/PowerAndBalancingStore/PowerAndBalancingStore';
import FrequencyAndBalancingStore from 'src/integration/store/FrequencyAndBalancingStore/FrequencyAndBalancingStore';
import RevenueStore from 'src/integration/store/RevenueStore/RevenueStore';
import EnergyStore from 'src/integration/store/EnergyStore/EnergyStore';
import BatteryStore from 'src/integration/store/BatteryStore/BatteryStore';
import RevenueTotalStore from 'src/integration/store/RevenueStore/RevenueTotalStore';
import SettingsStore from 'src/integration/store/SettingsStore/SettingsStore';
import RevenueByMarketStore from 'src/integration/store/RevenueByMarketStore/RevenueByMarketStore';

export interface Store {
  configStore: ConfigStore;
  profileStore: ProfileStore;
  dashboardStore: DashboardStore;
  operationalDataStore: OperationalDataStore;
  socAndBalancingStore: SocAndBalancingStore;
  powerAndBalancingStore: PowerAndBalancingStore;
  frequencyAndBalancingStore: FrequencyAndBalancingStore;
  revenueStore: RevenueStore;
  revenueTotalStore: RevenueTotalStore;
  revenueByMarketStore: RevenueByMarketStore;
  energyStore: EnergyStore;
  batteryStore: BatteryStore;
  settingsStore: SettingsStore;
}

export const store: Store = {
  configStore: new ConfigStore(),
  profileStore: new ProfileStore(),
  dashboardStore: new DashboardStore(),
  operationalDataStore: new OperationalDataStore(),
  socAndBalancingStore: new SocAndBalancingStore(),
  powerAndBalancingStore: new PowerAndBalancingStore(),
  frequencyAndBalancingStore: new FrequencyAndBalancingStore(),
  revenueStore: new RevenueStore(),
  revenueTotalStore: new RevenueTotalStore(),
  revenueByMarketStore: new RevenueByMarketStore(),
  energyStore: new EnergyStore(),
  batteryStore: new BatteryStore(),
  settingsStore: new SettingsStore()

};

export const StoreContext = createContext(store);

export const useStore = () => {
  return useContext(StoreContext);
};
